export const USE_ACCOUNTING_FLOW = 'use-accounting-flow';
export const USE_ACCOUNTING_NA_REVENUE = 'Accounting-owner-portal-NA-revenue';
export const USE_NEW_OWNER_RESERVATIONS =
  'OP-owner-reservations-to-actual-reservations';
export const USE_RESERVATION_DRAWER = 'OWN-use-reservation-drawer';
export const OWN_GUESTS_REPORTS_V2 = 'OWN-guests-reports-v2';
export const OWN_1099 = 'OWN_1099';
export const OWN_DASHBOARD = 'OWN-dashboard-page';
export const OWN_FRACTIONAL_OWNERSHIP = 'OWN-fractional-ownership';
